import {
  key,
  iv,
  appSecret,
  appVector,
} from "app/modules/camera/_redux/constants";
import forge from "node-forge";
export const getAvatar = (avatar) => {
  try {
    if (avatar && avatar !== undefined) {
      //admin.giaohangtietkiem.vnnnn/admin/files/uploads/images/profile/2019/07/09/JPEG_20190709_163548_2229676149437685840.jpg
      // eslint-disable-next-line no-labels
      return avatar.replace("https://admin", "https://cache");
    } else return avatar;
  } catch (error) {
    return null;
  }
};

export const province_names = {
  1: {
    name: "Hà Nội",
    region: 10,
  },
  126: {
    name: "TP Hồ Chí Minh",
    region: 30,
  },
  129: {
    name: "Đà Nẵng",
    region: 20,
  },
  130: {
    name: "Sơn La",
    region: 10,
  },
  132: {
    name: "Yên Bái",
    region: 10,
  },
  134: {
    name: "Lạng Sơn",
    region: 10,
  },
  135: {
    name: "Hải Phòng",
    region: 10,
  },
  137: {
    name: "Tuyên Quang",
    region: 10,
  },
  143: {
    name: "Quảng Trị",
    region: 20,
  },
  144: {
    name: "Bắc Giang",
    region: 10,
  },
  805: {
    name: "Hải Dương",
    region: 10,
  },
  806: {
    name: "Cần Thơ",
    region: 30,
  },
  807: {
    name: "Hà Nam",
    region: 10,
  },
  808: {
    name: "Lào Cai",
    region: 10,
  },
  811: {
    name: "Nam Định",
    region: 10,
  },
  812: {
    name: "Bình Thuận",
    region: 30,
  },
  816: {
    name: "Hưng Yên",
    region: 10,
  },
  818: {
    name: "Quảng Bình",
    region: 20,
  },
  819: {
    name: "Quảng Ninh",
    region: 10,
  },
  821: {
    name: "Nghệ An",
    region: 20,
  },
  823: {
    name: "Đồng Nai",
    region: 30,
  },
  824: {
    name: "Tiền Giang",
    region: 30,
  },
  826: {
    name: "Bình Định",
    region: 20,
  },
  827: {
    name: "Vĩnh Phúc",
    region: 10,
  },
  830: {
    name: "Hà Giang",
    region: 10,
  },
  831: {
    name: "Khánh Hòa",
    region: 20,
  },
  833: {
    name: "An Giang",
    region: 30,
  },
  834: {
    name: "Bà Rịa - Vũng Tàu",
    region: 30,
  },
  835: {
    name: "Bắc Kạn",
    region: 10,
  },
  836: {
    name: "Bạc Liêu",
    region: 30,
  },
  837: {
    name: "Bắc Ninh",
    region: 10,
  },
  838: {
    name: "Bến Tre",
    region: 30,
  },
  839: {
    name: "Bình Dương",
    region: 30,
  },
  840: {
    name: "Bình Phước",
    region: 30,
  },
  841: {
    name: "Cà Mau",
    region: 30,
  },
  842: {
    name: "Cao Bằng",
    region: 10,
  },
  843: {
    name: "Đắk Lắk",
    region: 20,
  },
  844: {
    name: "Đắk Nông",
    region: 20,
  },
  845: {
    name: "Điện Biên",
    region: 10,
  },
  846: {
    name: "Đồng Tháp",
    region: 30,
  },
  847: {
    name: "Gia Lai",
    region: 20,
  },
  848: {
    name: "Hà Tĩnh",
    region: 20,
  },
  849: {
    name: "Hậu Giang",
    region: 30,
  },
  850: {
    name: "Hòa Bình",
    region: 10,
  },
  851: {
    name: "Kiên Giang",
    region: 30,
  },
  852: {
    name: "Kon Tum",
    region: 20,
  },
  853: {
    name: "Lai Châu",
    region: 10,
  },
  854: {
    name: "Lâm Đồng",
    region: 30,
  },
  855: {
    name: "Long An",
    region: 30,
  },
  856: {
    name: "Ninh Bình",
    region: 10,
  },
  857: {
    name: "Ninh Thuận",
    region: 30,
  },
  858: {
    name: "Phú Thọ",
    region: 10,
  },
  859: {
    name: "Quảng Nam",
    region: 20,
  },
  860: {
    name: "Quảng Ngãi",
    region: 20,
  },
  861: {
    name: "Sóc Trăng",
    region: 30,
  },
  862: {
    name: "Tây Ninh",
    region: 30,
  },
  863: {
    name: "Thái Bình",
    region: 10,
  },
  864: {
    name: "Thái Nguyên",
    region: 10,
  },
  865: {
    name: "Thanh Hóa",
    region: 20,
  },
  866: {
    name: "Thừa Thiên Huế",
    region: 20,
  },
  867: {
    name: "Trà Vinh",
    region: 30,
  },
  868: {
    name: "Vĩnh Long",
    region: 30,
  },
  869: {
    name: "Phú Yên",
    region: 20,
  },
};

export const province_names_arr = [
  {
    name: "Hà Nội",
    region: 10,
    id: 1,
  },
  {
    name: "TP Hồ Chí Minh",
    region: 30,
    id: 126,
  },
  {
    name: "Đà Nẵng",
    region: 20,
    id: 129,
  },
  {
    name: "Sơn La",
    region: 10,
    id: 130,
  },
  {
    name: "Yên Bái",
    region: 10,
    id: 132,
  },
  {
    name: "Lạng Sơn",
    region: 10,
    id: 134,
  },
  {
    name: "Hải Phòng",
    region: 10,
    id: 135,
  },
  {
    name: "Tuyên Quang",
    region: 10,
    id: 137,
  },
  {
    name: "Quảng Trị",
    region: 20,
    id: 143,
  },
  {
    name: "Bắc Giang",
    region: 10,
    id: 144,
  },
  {
    name: "Hải Dương",
    region: 10,
    id: 805,
  },
  {
    name: "Cần Thơ",
    region: 30,
    id: 806,
  },
  {
    name: "Hà Nam",
    region: 10,
    id: 807,
  },
  {
    name: "Lào Cai",
    region: 10,
    id: 808,
  },
  {
    name: "Nam Định",
    region: 10,
    id: 811,
  },
  {
    name: "Bình Thuận",
    region: 30,
    id: 812,
  },
  {
    name: "Hưng Yên",
    region: 10,
    id: 816,
  },
  {
    name: "Quảng Bình",
    region: 20,
    id: 818,
  },
  {
    name: "Quảng Ninh",
    region: 10,
    id: 819,
  },
  {
    name: "Nghệ An",
    region: 20,
    id: 821,
  },
  {
    name: "Đồng Nai",
    region: 30,
    id: 823,
  },
  {
    name: "Tiền Giang",
    region: 30,
    id: 824,
  },
  {
    name: "Bình Định",
    region: 20,
    id: 826,
  },
  {
    name: "Vĩnh Phúc",
    region: 10,
    id: 827,
  },
  {
    name: "Hà Giang",
    region: 10,
    id: 830,
  },
  {
    name: "Khánh Hòa",
    region: 20,
    id: 831,
  },
  {
    name: "An Giang",
    region: 30,
    id: 833,
  },
  {
    name: "Bà Rịa - Vũng Tàu",
    region: 30,
    id: 834,
  },
  {
    name: "Bắc Kạn",
    region: 10,
    id: 835,
  },
  {
    name: "Bạc Liêu",
    region: 30,
    id: 836,
  },
  {
    name: "Bắc Ninh",
    region: 10,
    id: 837,
  },
  {
    name: "Bến Tre",
    region: 30,
    id: 838,
  },
  {
    name: "Bình Dương",
    region: 30,
    id: 839,
  },
  {
    name: "Bình Phước",
    region: 30,
    id: 840,
  },
  {
    name: "Cà Mau",
    region: 30,
    id: 841,
  },
  {
    name: "Cao Bằng",
    region: 10,
    id: 842,
  },
  {
    name: "Đắk Lắk",
    region: 20,
    id: 843,
  },
  {
    name: "Đắk Nông",
    region: 20,
    id: 844,
  },
  {
    name: "Điện Biên",
    region: 10,
    id: 845,
  },
  {
    name: "Đồng Tháp",
    region: 30,
    id: 846,
  },
  {
    name: "Gia Lai",
    region: 20,
    id: 847,
  },
  {
    name: "Hà Tĩnh",
    region: 20,
    id: 848,
  },
  {
    name: "Hậu Giang",
    region: 30,
    id: 849,
  },
  {
    name: "Hòa Bình",
    region: 10,
    id: 850,
  },
  {
    name: "Kiên Giang",
    region: 30,
    id: 851,
  },
  {
    name: "Kon Tum",
    region: 20,
    id: 852,
  },
  {
    name: "Lai Châu",
    region: 10,
    id: 853,
  },
  {
    name: "Lâm Đồng",
    region: 30,
    id: 854,
  },
  {
    name: "Long An",
    region: 30,
    id: 855,
  },
  {
    name: "Ninh Bình",
    region: 10,
    id: 856,
  },
  {
    name: "Ninh Thuận",
    region: 30,
    id: 857,
  },
  {
    name: "Phú Thọ",
    region: 10,
    id: 858,
  },
  {
    name: "Quảng Nam",
    region: 20,
    id: 859,
  },
  {
    name: "Quảng Ngãi",
    region: 20,
    id: 860,
  },
  {
    name: "Sóc Trăng",
    region: 30,
    id: 861,
  },
  {
    name: "Tây Ninh",
    region: 30,
    id: 862,
  },
  {
    name: "Thái Bình",
    region: 10,
    id: 863,
  },
  {
    name: "Thái Nguyên",
    region: 10,
    id: 864,
  },
  {
    name: "Thanh Hóa",
    region: 20,
    id: 865,
  },
  {
    name: "Thừa Thiên Huế",
    region: 20,
    id: 866,
  },
  {
    name: "Trà Vinh",
    region: 30,
    id: 867,
  },
  {
    name: "Vĩnh Long",
    region: 30,
    id: 868,
  },
  {
    name: "Phú Yên",
    region: 20,
    id: 869,
  },
];

export const region_names = {
  10: "Miền Bắc",
  20: "Miền Trung",
  30: "Miền Nam",
  40: "Xe Thuê",
};
export const convertGroupStation = (data) => {
  let region = {};
  let province = {};
  let dataMenu = [];
  let item_region = {};
  let item_province = {};
  let count = 0;
  let count_province = 0;
  data = data.filter((item) => item.province_id !== "0");
  for (let i = 0; i < data.length; i++) {
    let element = data[i];
    item_province = {};
    if (
      region[element.region] === undefined ||
      region[element.region] === null
    ) {
      region[element.region] = count;
      item_region = {
        region: element.region,
        region_name: region_names[element.region],
        provinces: [],
      };
      if (!province_names[element.province_id]) {
      }
      item_province = {
        province_id: element.province_id,
        province_name: province_names[element.province_id].name,
        stations: [element],
      };
      province[element.province_id] = count_province;

      item_region.provinces.push(item_province);
      dataMenu.push(item_region);
      count += 1;
    } else {
      item_region = {
        region: element.region,
        provinces: [],
      };
      if (province[element.province_id] !== undefined) {
        item_province =
          dataMenu[region[element.region]].provinces[
            province[element.province_id]
          ];
        item_province.stations.push(element);
        dataMenu[region[element.region]].provinces[
          province[element.province_id]
        ] = item_province;
      } else {
        count_province += 1;
        item_province = {
          province_id: element.province_id,
          province_name: province_names[element.province_id].name,
          stations: [],
        };
        item_province.stations.push(element);
        province[element.province_id] = count_province;
        dataMenu[region[element.region]].provinces[
          province[element.province_id]
        ] = item_province;
      }
    }
  }
  return dataMenu;
};

export const convertRegionProvinceStation = (data) => {
  let region = [];
  let province = [];
  let station = [];
  let dataReturn = [];

  for (var i = 0; i < data.length; i++) {
    let element = data[i];

    if (isNaN(parseInt(element))) {
      if (element === "Miền Bắc") {
        region.push(10);
      }
      if (element === "Miền Trung") {
        region.push(20);
      }
      if (element === "Miền Nam") {
        region.push(30);
      }
      if (element === "Xe Thuê") {
        region.push(40);
      }
      province_names_arr.forEach((item) => {
        if (item.name === element) {
          province.push(item.id);
        }
      });
    } else {
      station.push(parseInt(element));
    }
  }
  dataReturn = {
    region_id: region,
    province_id: province,
    station_id: station,
  };
  return dataReturn;
};

export const convertRegionProvinceCompanyStation = (data, listXeThue) => {
  let region = [];
  let province = [];
  let station = [];
  let dataReturn = [];

  for (var i = 0; i < data.length; i++) {
    let element = data[i];
    let id = parseInt(element);
    let isStation = element.includes("#");
    if (!isStation) {
      //miền và tỉnh
      if (id < 1000000) {
        if (element === "10") {
          region.push(10);
        } else if (element === "20") {
          region.push(20);
        } else if (element === "30") {
          region.push(30);
        } else if (element === "40") {
          region.push(40);
        } else {
          province_names_arr.forEach((item) => {
            if (item.id == element) {
              province.push(item.id);
            }
          });
        }
      } else {
        // xe thuê
        listXeThue.forEach((item) => {
          if (item.province_id == element) {
            province.push(item.province_id);
          }
        });
      }
    } else {
      // kho
      let station_id = element.split("#");
      station.push(station_id[0]);
    }
  }
  dataReturn = {
    region_id: region,
    province_id: province,
    station_id: station,
  };
  return dataReturn;
};

export const decode = (passEncode) => {
  let forge = require("node-forge");
  if (!passEncode) return passEncode;
  const key = "4z6C9EbGeKgNjRnTqVtYv2y5A7CaFcNf";
  const iv = "bH1SiWTMuELhuGaqtk3Y1A==";
  let decipher = forge.cipher.createDecipher("AES-CBC", key);
  decipher.start({ iv: iv });
  decipher.update(forge.util.createBuffer(forge.util.decode64(passEncode)));
  let result = decipher.finish();
  if (result) return decipher.output.toString();
  return false;
};

export var encrypt = function (plainText) {
  let forge = require("node-forge");
  if (!plainText) {
    return plainText;
  }
  var cipher = forge.cipher.createCipher("AES-CBC", key);
  cipher.start({ iv: iv });
  cipher.update(forge.util.createBuffer(plainText));
  cipher.finish();
  var encrypted = cipher.output;
  var encodedB64 = forge.util.encode64(encrypted.data);
  return encodedB64;
};

export var passwordEncrypt = function (plainText) {
  let forge = require("node-forge");
  if (!plainText) {
    return plainText;
  }
  var cipher = forge.cipher.createCipher("AES-CBC", key);
  cipher.start({ iv: iv });
  cipher.update(forge.util.createBuffer(plainText));
  cipher.finish();
  var encrypted = cipher.output;
  var encodedB64 = forge.util.encode64(encrypted.data);
  return encodedB64;
};

export function removeVietnameseTones(str) {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
  str = str.replace(/Đ/g, "D");
  // Some system encode vietnamese combining accent as individual utf-8 characters
  // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
  // Remove extra spaces
  // Bỏ các khoảng trắng liền nhau
  str = str.replace(/ + /g, " ");
  str = str.trim();
  // Remove punctuations
  // Bỏ dấu câu, kí tự đặc biệt
  str = str.replace(
    /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
    " "
  );
  return str;
}